import React from 'react';
import { useState, useEffect } from 'react';
import Scrollbar from '../../../Scrollbar';
// material
import {
    Table,
    TableBody,
    TableContainer,
    Pagination,
    Box,
    Typography,
    TableCell,
    TableRow
} from '@mui/material';
import CommonTableHead from '../../../foodVendor/reports/commonTableHead.js';
import { getActivityWatcher } from '../../../../redux/actionCreators/admin/reports';
import { useDispatch, useSelector } from 'react-redux';
import ActivityTableRow from './tableRow';

export const TABLE_HEAD = [
    // { id: 'cRFID', label: 'cRFID', alignRight: false, title: 'cRFID', field: 'cRFID' },
    { id: 'cUserName', label: 'User Name', alignRight: false, title: 'User Name', field: 'cUserName' },
    { id: 'createdAt', label: 'CreatedAt', alignRight: false, title: 'CreatedAt', field: 'createdAt' },
    { id: 'device', label: 'Device', alignRight: false, title: 'Device', field: 'device' },
    { id: 'cName', label: 'Counter', alignRight: false, title: 'cName', field: 'cName' },
    // { id: 'nID', label: 'nID', alignRight: false, title: 'nID', field: 'nID' },
    { id: 'orderBy', label: 'OrderBy', alignRight: false, title: 'OrderBy', field: 'orderBy' },
    { id: 'session', label: 'Session', alignRight: false, title: 'Session', field: 'session' },
    { id: 'status', label: 'Status', alignRight: false, title: 'Status', field: 'status' },
    // { id: 'action', label: 'Action', alignRight: false },
];


function descendingComparator(a, b, orderBy) {
    if (b[orderBy] < a[orderBy]) {
        return -1;
    }
    if (b[orderBy] > a[orderBy]) {
        return 1;
    }
    return 0;
}

function getComparator(order, orderBy) {
    return order === 'desc'
        ? (a, b) => descendingComparator(a, b, orderBy)
        : (a, b) => -descendingComparator(a, b, orderBy);
}

function applySortFilter(array, comparator) {
    const stabilizedThis = array.map((el, index) => [el, index]);
    stabilizedThis.sort((a, b) => {
        const order = comparator(a[0], b[0]);
        if (order !== 0) return order;
        return a[1] - b[1];
    });
    return stabilizedThis.map((el) => el[0]);
}

const ActivityTable = ({ searchVal, searchText, page, setPage }) => {

    const { ReportsReducers: { ActivityList } } = useSelector((state) => state)

    let firstIndex = 0;

    const dispatch = useDispatch();
    const [order, setOrder] = useState('asc');
    const [orderBy, setOrderBy] = useState('name');
    const [rowsPerPage] = useState(5);

    useEffect(() => {
        let data = {
            "Action": "SELECT"
        }
        dispatch(getActivityWatcher(data))
    }, [dispatch])

    const handleRequestSort = (event, property) => {
        const isAsc = orderBy === property && order === 'asc';
        setOrder(isAsc ? 'desc' : 'asc');
        setOrderBy(property);
    };

    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };


    const tableData = searchText ? searchVal : ActivityList
    const filteredData = applySortFilter(tableData, getComparator(order, orderBy));
    const isUserNotFound = filteredData?.length === 0;

    return (
        <>
            <Box>
                <Scrollbar>
                    <TableContainer sx={{overflow:'unset'}} >
                        <Table>
                            <CommonTableHead
                                order={order}
                                orderBy={orderBy}
                                headLabel={TABLE_HEAD}
                                onRequestSort={handleRequestSort}
                            />
                            <TableBody>
                                {filteredData?.slice(firstIndex + rowsPerPage * (page - 1), rowsPerPage * page)
                                    .map((f, i) => {
                                        return (
                                            <ActivityTableRow key={i} rowData={f} index={i} />
                                        )
                                    })}
                            </TableBody>
                            {isUserNotFound && (
                                <TableBody>
                                    <TableRow display='flex'>
                                        <TableCell align="center" colSpan={8} sx={{ py: 3 }}>
                                            <Typography variant='t18_500' >
                                                No records found
                                            </Typography>
                                        </TableCell>
                                    </TableRow>
                                </TableBody>
                            )}
                        </Table>
                    </TableContainer>
                </Scrollbar>
            </Box>
            <Box spacing={2} display='flex' justifyContent='right' paddingTop='20px' >
                <Pagination
                    shape="rounded"
                    color='primary'
                    count={Math.ceil(tableData?.length / rowsPerPage)}
                    page={page}
                    onChange={handleChangePage}
                />
            </Box>
        </>
    )
}

export default ActivityTable;